import type { KeyValue } from 'ngrx-forms';

import type { NGRXProgressiveFormsActions } from '../actions';
import { MarkAsInertAction } from '../actions';
import type { ProgressiveFormGroupState } from '../state';

export function markAsInertReducer<TValue extends KeyValue>(
  state: ProgressiveFormGroupState<TValue>,
  action: NGRXProgressiveFormsActions
): ProgressiveFormGroupState<TValue> {
  if (action.type !== MarkAsInertAction.TYPE) {
    return state;
  }

  if (action.stepId !== state.id) {
    return state;
  }

  if (state.isInert) {
    return state;
  }

  return {
    ...state,
    isEditable: false,
    isInert: true,
  };
}
